import { Component, OnInit } from '@angular/core';
import { APIServerResponse, NewsCO } from 'src/app/shared/models/ApiModels';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ApiUrls } from 'src/app/shared/const/Api-urls';
import { ApiService } from 'src/app/shared/services/api.service';
import * as moment from 'moment';

@Component({
  selector: 'app-view-news',
  templateUrl: './view-news.component.html',
  styleUrls: ['./view-news.component.scss']
})
export class ViewNewsComponent implements OnInit {

  selectedNews?: NewsCO;
  newsList: NewsCO[] = [];

  imageBaseUrl = `${ApiUrls.downloadFileUrl1}`;
  defaultImg = 'assets/news.jpg';

  constructor(
    private apiService: ApiService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.loadSelectedNews();
    this.getNewsList();
  }

  private loadSelectedNews(): void {
    const storedNews = sessionStorage.getItem('selectedNews');

    if (!storedNews) {
      console.warn('No selected news found in sessionStorage');
      return;
    }

    try {
      this.selectedNews = JSON.parse(storedNews);console.log(this.selectedNews)
    } catch (error) {
      console.error('Invalid selectedNews JSON', error);
      sessionStorage.removeItem('selectedNews');
    }
  }

  transformDate(date?: string | Date): string {
    if (!date) {
      return '';
    }
    let modDate = moment(date, 'DD/MM/YYYY HH:mm').format('DD MMM YYYY HH:mm');

    return modDate;
   
  }

  getNewsList(): void {
    this.apiService.getNewsByStatus({ status: 'ACTIVE' }).subscribe({
      next: (res: any) => {
        this.newsList = res?.data ?? [];
      },
      error: (err: any) => {
        console.error('Failed to load news list', err);
        this.newsList = [];
      }
    });
  }

  getSafeDescription(html?: string): SafeHtml {
    return html ? this.sanitizer.bypassSecurityTrustHtml(html) : '';
  }
}
